module.exports = __webpack_public_path__ + "static/media/1664.d1d0eaed.jpg";